module.exports = __webpack_public_path__ + "static/media/patra.73c8395b.jpeg";